import { Module } from 'wrapper6'

export default class Modal extends Module {
    ready() {
        const closeTriggers = document.querySelectorAll('[data-close-modal]')
        const openTriggers = document.querySelectorAll('[data-open-modal]')

        if (closeTriggers.length) {
            closeTriggers.forEach(trigger => {
                trigger.addEventListener('click', event => {
                    if (event.target !== trigger) {
                        return
                    }

                    event.preventDefault()
                    const modalID = this.getModalID(trigger)
                    this.closeModal(modalID)
                })
            })
        }

        if (openTriggers.length) {
            openTriggers.forEach(trigger => {
                trigger.addEventListener('click', event => {
                    event.preventDefault()
                    const modalID = this.getModalID(trigger)
                    this.openModal(modalID)
                })
            })
        }
    }

    getModalID (trigger) {
        return trigger.getAttribute('data-close-modal')
    }

    getModal (id) {
        return document.querySelector(`[data-modal-id="${id}"]`)
    }

    closeModal (id) {
        const modalElement = this.getModal(id)
        modalElement.classList.remove('mtt-modal--visible')
    }

    openModal (id) {
        const modalElement = this.getModal(id)
        modalElement.classList.add('mtt-modal--visible')
    }
}
